/**
 * Onboarding store
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ONBOARDING_STEPS, TOTAL_STEPS } from '../types/onboarding.js';
const defaultData = {
    profileSetup: false,
    firstMeetingCreated: false,
    featuresViewed: [],
};
const defaultState = {
    isCompleted: false,
    currentStep: ONBOARDING_STEPS.WELCOME,
    completedSteps: [],
    skipped: false,
    data: defaultData,
};
export const useOnboardingStore = create()(persist((set, get) => ({
    ...defaultState,
    completeStep: (step) => {
        const state = get();
        const newCompletedSteps = [...state.completedSteps];
        if (!newCompletedSteps.includes(step)) {
            newCompletedSteps.push(step);
        }
        const isCompleted = newCompletedSteps.length >= TOTAL_STEPS || step === ONBOARDING_STEPS.COMPLETION;
        set({
            completedSteps: newCompletedSteps,
            currentStep: isCompleted ? ONBOARDING_STEPS.COMPLETION : step + 1,
            isCompleted,
        });
    },
    skipOnboarding: () => {
        set({
            skipped: true,
            isCompleted: false,
        });
    },
    resetOnboarding: () => {
        set(defaultState);
    },
    updateOnboardingData: (data) => {
        const state = get();
        set({
            data: {
                ...state.data,
                ...data,
            },
        });
    },
    setCurrentStep: (step) => {
        set({ currentStep: step });
    },
    initialize: (profile) => {
        if (!profile) {
            return;
        }
        set({
            isCompleted: profile.onboardingCompleted || false,
            currentStep: profile.onboardingStep || ONBOARDING_STEPS.WELCOME,
            skipped: profile.onboardingSkipped || false,
            data: profile.onboardingData || defaultData,
        });
    },
}), {
    name: 'voxapilot-onboarding',
}));
//# sourceMappingURL=onboarding.js.map